export enum EPType {
  All = 'All',
  Internal = 'Internal',
  External = 'External',
  EC2 = 'EC2',
}
